import { render, staticRenderFns } from "./generarEtiquetas.vue?vue&type=template&id=4e72bfbe&scoped=true"
import script from "./generarEtiquetas.vue?vue&type=script&lang=js"
export * from "./generarEtiquetas.vue?vue&type=script&lang=js"
import style0 from "./generarEtiquetas.vue?vue&type=style&index=0&id=4e72bfbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72bfbe",
  null
  
)

export default component.exports